import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getIconThemeConfig, IconButtonContainer } from '../styles';
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      screenReaderOnlyText = _ref.screenReaderOnlyText,
      disabled = _ref.disabled,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      theme = _ref.theme,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'simple' : _ref$variant,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "screenReaderOnlyText", "disabled", "data-test", "type", "theme", "variant"]);

  var componentTheme = useComponentTheme({
    name: 'IconButton',
    theme: getIconThemeConfig(theme)
  }); // we enforce specific icon sizes according to the overall button size

  var cloneProps = {
    size: componentTheme[size].size
  };
  return /*#__PURE__*/React.createElement(IconButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    "aria-label": screenReaderOnlyText,
    ref: ref,
    disabled: disabled,
    size: size,
    type: type,
    customTheme: componentTheme,
    variant: variant
  }), /*#__PURE__*/React.cloneElement(children, cloneProps));
});
IconButton.displayName = 'IconButton';
export default IconButton;